var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfoEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93819 2H3.75C2.7835 2 2 2.7835 2 3.75V14.25C2 15.2165 2.7835 16 3.75 16H14.25C15.2165 16 16 15.2165 16 14.25V7.59326L14.25 9.357V14.25H3.75V3.75L8.20183 3.75L9.93819 2Z",
    fill: "#1D4ED7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.25H9.93L15.33 5.85004L12.15 2.67004L6.75 8.07004V11.25Z",
    fill: "#1D4ED7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1825 1.86753L16.125 0.810027C15.54 0.225027 14.5875 0.225027 14.0025 0.810027L13.2075 1.60503L16.3875 4.78503L17.1825 3.99003C17.775 3.40503 17.775 2.45253 17.1825 1.86753Z",
    fill: "#1D4ED7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoEdit);
export default __webpack_public_path__ + "static/media/icon-info-edit.5bd24fe1283406858afd00b6b37bfa0e.svg";
export { ForwardRef as ReactComponent };